export const scheduleGroupIdSearchParam = 'scheduleGroupId';
